import type { PrV2CollapsibleTreeNode } from './pr-v2-file-tree-types';

function stripGroupingParens(value: string): string {
  return value.replace(/^\(([^)]+)\)$/, '$1');
}

function toNormalizedSegments(value: string): string[] {
  return value
    .split('/')
    .map((segment) => stripGroupingParens(segment))
    .filter((segment) => segment.length > 0);
}

function shouldAvoidMerge(current: string, child: string): boolean {
  const currentSegments = toNormalizedSegments(current);
  const childSegments = toNormalizedSegments(child);
  return currentSegments.some((segment) => childSegments.includes(segment));
}

export function collapseSingleChildFolderChain<TFileRecord>(
  folderName: string,
  node: PrV2CollapsibleTreeNode<TFileRecord>,
): { mergedFolderName: string; terminalNode: PrV2CollapsibleTreeNode<TFileRecord> } {
  let mergedFolderName = folderName;
  let terminalNode = node;

  while (terminalNode.files.length === 0 && terminalNode.folders.size === 1) {
    const childEntry = terminalNode.folders.entries().next();
    if (childEntry.done) {
      break;
    }

    const [childFolderName, childNode] = childEntry.value;

    if (shouldAvoidMerge(mergedFolderName, childFolderName)) {
      break;
    }

    mergedFolderName = `${mergedFolderName}/${childFolderName}`;
    terminalNode = childNode;
  }

  return {
    mergedFolderName,
    terminalNode,
  };
}
